import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import * as moment from 'moment';
import { environment } from '../../../../environments/environment';
import { AccessLevel } from '../../../common/enums/access-level.enum';
import { Permission } from '../../../common/enums/permission.enum';
import { CacheKey } from '../../../shared/constants/cachekey.constants';
import { Country } from '../../../shared/interface/country.interface';
import { StoreConfig } from '../../../shared/interface/StoreConfig.interface';
import { UserInfo } from '../../../shared/interface/user-info.interface';
import { CacheService } from '../../../shared/services/cache.service';
import { CommonService } from '../../../shared/services/common.service';
import { Utils } from '../../../shared/Utils/utils';
import { DateConstants } from '../../constants/date.constants';
import { SubCategoryConstants } from '../../constants/reports.constants';
import { OperatingCountryEnums } from '../../enums/countries.enums';
import { ReportCategoryEnum,ReportCategoryNameEnum } from '../../enums/report-category.enum';
import { Period } from '../../enums/period.enum';
import { ReportTab } from '../../enums/report-tab.enum';
import { OperatingCountry } from '../../interface/operating-country.interface';
import { CustomerService } from '../../services/customer.service';
import { OrderService } from '../../services/order.service';
import { isNullOrUndefined } from 'util';
import { MemberStatus } from '../../enums/member-status.enum';

@Component({
    selector: 'app-csp-reports',
    templateUrl: '../../templates/template1/views/reports/reports.component.html',
styleUrls: ['../../templates/template1/themes/default/less/reports.component.less']
})
export class ReportsComponent implements OnInit {

    operatingCountries: OperatingCountry[] = [];
    countries = [];
    stores: Country[] = [];
    businessEntities = [];
    userInfo: UserInfo;
    reportsForm: FormGroup = null;
    reportsCategoryEnum = ReportCategoryEnum;
    activeTab = ReportTab.INVOICE_PRINTING;
    reportCategories = [];
    posLocations = [];
    subReports = [];
    subCategoryConstants = SubCategoryConstants;
    storeId: number;
    storeInfo: StoreConfig;
    operatingCountryCode: string;
    currentDate = new Date();
    fromDate: any;
    toDate: any;
    formattedFromDate: Date | string;
    formattedToDate: Date | string;
    isSubmitted: boolean = false;
    isLoading: boolean = false;
    areaCode = '';
    dataLoadedCount = 0;
    momentConstructor: (value?: any) => moment.Moment = (<any>moment).default || moment;
    dateRangeDuration = environment.reportDownloadDurationMonths;
    posPaymentMethods = [];
    reportTab = ReportTab;
    hasManageReportPermission: boolean= false;
    hasInvoicePrintingPermission: boolean= false;
    hasRunReportPermission: boolean= false;
    reportPermission: any[] = [
        Permission.MANAGE_REPORTS,
        Permission.RUN_REPORTS,
        Permission.INVOICE_PRINTING
    ];
    period = Period;
    finalStoreIds = [];
    countryAndStoreData: any[] = [];


    countryIdForBsn = [];
    countryIdForIBAN = [];
    displayCountryName = null;

    // for dropdown
    /* for dropdown*/
    dropdownList = [];
    selectedItems = [];
    dropdownSettings : {};

    /* custom date ranges for order reports subcategory and order dashboard subcategory*/
    minDateRangeForDatePicker = null;
    selectAllStores = false;
    defaultLoad = true;
    memberStatus = [];
    previousStatus ='';
    newStatus ='';
 
    email = '';
    fboId = '';
    
    constructor(
        private _customerService: CustomerService,
        private _cacheService: CacheService,
        private _formbuilder: FormBuilder,
        private _orderService: OrderService,
        private _commonService: CommonService
    ) {
    }

    ngOnInit() {
        this.userInfo = this._cacheService.get(CacheKey.UserInfo);
        this.getPermissions();
        this.getCountries();
        this.getOperatingCountries();
        this.buildReportsForm();
        this.fromDate = this.momentConstructor(this.currentDate);
        this.toDate = this.momentConstructor(this.currentDate);
        this.getPosPaymentMethod();
        this.getSingleCountry()

        this.callingMultiSelect();

        //  for multi-select dropdown
        this.getReportCategories();
        this.getMemberStatus();
    }

    /**
     * To get agent permission
     */
    getPermissions() {
        this.hasManageReportPermission = this._commonService.checkPermissionByAccessLevel(JSON.parse('[' + this.reportPermission[0] + ']'), AccessLevel.Customer_Service);
        this.hasRunReportPermission = this._commonService.checkPermissionByAccessLevel(JSON.parse('[' + this.reportPermission[1] + ']'), AccessLevel.Customer_Service);
        this.hasInvoicePrintingPermission = this._commonService.checkPermissionByAccessLevel(JSON.parse('[' + this.reportPermission[2] + ']'), AccessLevel.Customer_Service);
        this.activeTab = (this.hasManageReportPermission && this.hasInvoicePrintingPermission) ? this.reportTab.INVOICE_PRINTING : this.reportTab.REPORT;
    }

    /**
     * To build reports form
     */
    buildReportsForm(): void {
        this.reportsForm = this._formbuilder.group({
            operatingCountry: ['', Validators.required],
            store: ['', [Validators.required]],
            reportCategory: ['', [Validators.required]],
            subCategory: ['', [Validators.required]],
            fromDate: ['', [Validators.required, Utils.validateFromDate()]],
            toDate: ['', [Validators.required, Utils.validateToDate()]],
            posLocationId: [''],
            notesRequired: [false],
            period:['',Validators.required],
            previousStatus: [''],
            newStatus: [''],
            email: [''],
            fboId: ['',Validators.minLength(12)]
        });
    }

    /**
     * To get all operating countries from configuration service
     */
    getOperatingCountries() {
        this._customerService.getAllBusinessEntities().subscribe((response: any) => {
            if (response) {
                this.businessEntities = response;
                this.getAllowedOperatingCountries();
            }
        }, (error) => {
            this.businessEntities = [];
        });
    }

    /**
     * To get allowed Countries based on permissions
     */
    getAllowedOperatingCountries() {
        let countryIds: any = [];
        if (this.userInfo && !this.userInfo.hasSystemRole) {
            if (this.userInfo.allowedOperatingCountries) {
                countryIds = this.userInfo.allowedOperatingCountries.split(',');
                countryIds = countryIds ? countryIds : [];
                if (countryIds && countryIds.length > 0) {
                    let ids = countryIds;
                    this.operatingCountries = this.businessEntities.filter(function (item) {
                        return ids.indexOf(item.id + '') !== -1;
                    });
                }
            } else {
                this.operatingCountries = [];
            }
        } else {
            this.operatingCountries = this.businessEntities;
        }
        this.operatingCountries.sort(function (item1, item2) {
            const country1 = item1.name.toLowerCase(), country2 = item2.name.toLowerCase();
            if (country1 < country2) {
                return -1;
            }
            if (country1 > country2) {
                return 1;
            }
            return 0;
        });
        const countryInfo = this.operatingCountries.find((country: any) => country.id === OperatingCountryEnums.USA);
        if (countryInfo) {
            // this.operatingCountries.splice(this.countries.indexOf(countryInfo), 1);
            // this.operatingCountries.splice(0, 0, countryInfo);
            this.reportsForm.controls['operatingCountry'].setValue(countryInfo.id);
            this.getStoresByCountryCode(countryInfo.id,countryInfo.value);
            this.defaultLoad = false;
        }
         if (this.countries && this.countries.length > 0 && !countryInfo && !this.defaultLoad) {
            this.getStoresByCountryCode(this.operatingCountries[0].id, this.operatingCountries[0].value);       
        }
    }

    /**
     * To get all countries from configuration service
     */
    getCountries() {
        this._customerService.getAllCountries(true).subscribe(response => {
            if (response) {
                this.countries = response;
                if (this.operatingCountries && this.operatingCountries.length > 0) {
                    this.getStoresByCountryCode(this.operatingCountries[0].id, this.operatingCountries[0].value);
                    this.callingMultiSelect();
                }
            }
        }, (error) => {
            this.countries = [];
        });
    }

    /**
     * To get operating country by country code
     */
    getStoresByCountryCode(operatingCountryId: number, isoCodeThree?: string) {
        this.operatingCountryCode = isoCodeThree ? isoCodeThree : this.operatingCountries.find(operatingCountry => operatingCountry.id === +operatingCountryId).value;
        this._customerService.getOperatingCountriesByCountryCode(this.operatingCountryCode, true).subscribe(response => {
            if (response && response.countriesUnderOperatingCountry && response.countriesUnderOperatingCountry.length > 0) {
                this.stores = [];
                response.countriesUnderOperatingCountry.forEach(countryOperatingCountry => {
                    const countries = this.countries.filter(country => country.titanPlatformEnabled && country.enrollmentEnabled && country.shopEnabled
                        && country.isocodeThree === countryOperatingCountry.countryCode);
                    if (countries && countries.length > 0) {
                        this.stores = this.stores.concat(countries);
                        this.dropdownList = [];
                        this.stores.forEach(obj=>{
                            const newStore = {"id":0,"itemName":""}
                            newStore.id =  obj.countryId;
                            newStore.itemName = obj.name;
                            this.dropdownList.push(newStore);
                        });
                        
                        this.callingMultiSelect();
                    }
                });
            } else {
                this.stores = [];
            }
        }, (error) => {
            this.stores = [];
        });
    }

    getSingleCountry(){
        this.operatingCountries.forEach(country=>{
            if(country.id == this.reportsForm.controls.operatingCountry.value ){
                this.displayCountryName = country.name;
            }
        })
    }

    /**
     * On operating country change event
     */
    onOperatingCountryChange(operatingCountryId: number): void {
        this.getSingleCountry()
        this.reportsForm.controls['store'].setValue('');
        this.reportsForm.controls['reportCategory'].setValue('');
        this.reportsForm.controls['subCategory'].setValue('');
        this.subReports = [];
        this.finalStoreIds = [];
        this.countryIdForBsn = [];
        this.countryIdForIBAN = [];
        this.reportsForm.controls['period'].setValue('');
        this.getStoresByCountryCode(operatingCountryId);
    }

    /**
     * On store change event
     */
    onStoreChange(id: number): void {
        this.posLocations = [];
        this.storeId = null;
        this.storeInfo = null;
        this.reportsForm.controls['subCategory'].setValue('');
        this.reportsForm.controls['posLocationId'].setValue('');
 //       this.reportsForm.controls['period'].setValue('');
        const countryCode = this.stores.filter(country => country.countryId === Number(id))[0].isocodeThree;
        this.getStoreInfo(countryCode);
    }

    /**
     * On report category change event
     */
      onReportCategoryChange(reportCategory: number): void {
        this.subReports = [];
        this.minDateRangeForDatePicker = null;
        this.reportsForm.controls['posLocationId'].setValue('');
        this.reportsForm.controls['subCategory'].setValue('');
       // this.reportsForm.controls['period'].setValue('');
        this.getReports(this.reportsForm.controls['operatingCountry'].value, this.reportsForm.controls['reportCategory'].value);
        if (reportCategory == ReportCategoryEnum.POS) {
            this.reportsForm.controls['posLocationId'].setValidators([Validators.required]); 
            this.posLocations = [];    
            this.finalStoreIds.forEach(StoreId => {
               this.getPOSLocations(StoreId);
            });
            
        } else {
            this.reportsForm.controls['posLocationId'].setValidators(null);
        }
        this.reportsForm.controls['posLocationId'].setValue('');
        this.reportsForm.controls['posLocationId'].updateValueAndValidity();
        this.dataLoadedCount = 0;
    }

    /**
     * To get report categories
     */
     getReportCategories(): void {
        this._customerService.getLookupConfigValues('reportCategory').subscribe(response => {
            if (response && response.length > 0) {
                this.reportCategories = response;
            } else {
                this.reportCategories = [];
            }
        }, (error) => {
            this.reportCategories = [];
        });
    }

    /**
     * To get POS location based on store
     */
    async getPOSLocations(storeId: number) {
        const posLocations = await this.getPOSLocationsByStoreId(storeId);
        posLocations.forEach(res => {
            let posId = false;
            this.posLocations.forEach(pos => {
                if (res.id === pos.id) { return posId = true; }
            })
            if (!posId) { this.posLocations.push(res) }
        })
    }
    getPOSLocationsByStoreId(storeId:number) : Promise<any>{
       return this._customerService.getPosLocationsByStore(storeId).toPromise()
    }
  
    /**
     * To get reports based on operating country
     */
    getReports(operatingCountryId: number, reportCategoryId: number) {
        this.isSubmitted = false;
        this._customerService.getReports(operatingCountryId, reportCategoryId).subscribe(response => {
            if (response && response.length > 0) {
                this.subReports = response;
            } else {
                this.subReports = [];
            }
        }, (error) => {
            this.subReports = [];
        });
    }

    /**
     * To get store info by countryCode
     */
    getStoreInfo(countryCode: string) {
        this._orderService.getStoreInfo(countryCode).subscribe(response => {
            if (response) {
                this.storeInfo = response;
                this.storeId = response.id;
                if (!this.reportCategories || this.reportCategories.length === 0) {
                    this.getReportCategories();
                }
            }
        }, (error) => {
            this.storeInfo = null;
        });
    }

    /**
     * When subCategory value changes
     */
    subCategoryChanged(): void {
        this.reportsForm.controls['posLocationId'].setValue('');
        this.formValuesChanged();
        if (this.subCategoryConstants.OrdersReport === this.reportsForm.controls.subCategory.value) {
            const  date = new Date();
            let currentMonthFirstDay = new Date(date.getFullYear(), date.getMonth(), 1).toLocaleDateString('en-CA');
            this.minDateRangeForDatePicker = currentMonthFirstDay
            this.setOrderReportsDeafultDateAndValidataors();
        } else if(this.subCategoryConstants.OrdersDashboard === this.reportsForm.controls.subCategory.value || this.subCategoryConstants.BSNReport ===  this.reportsForm.controls.subCategory.value || this.subCategoryConstants.IBANReport ===  this.reportsForm.controls.subCategory.value){
           this.setOrderDashboardReportsDeafultDateAndValidataors();
           const  date = new Date();
           let previousMonthFirstDay = new Date(date.getFullYear(), date.getMonth()-1, 1).toLocaleDateString('en-CA');
           this.minDateRangeForDatePicker = previousMonthFirstDay;
        } else if(this.subCategoryConstants.AccountStatusChange === this.reportsForm.controls.subCategory.value){
            this.setStatusDefaultValues();
            this.reportsForm.controls['period'].setValue('102');
            this.minDateRangeForDatePicker = null;
            this.setDefaultDateAndValidataors();
        } else if(this.subCategoryConstants.EnrollmentReport === this.reportsForm.controls.subCategory.value){
            this.setDefaultEnrollmentReportValues();
            this.minDateRangeForDatePicker = null;
            this.setDefaultDateAndValidataors();
        }
        else {
            this.minDateRangeForDatePicker = null;
            this.setDefaultDateAndValidataors();
        }
    }

     /**
     * Set Default for previous and new status
     */
    setStatusDefaultValues(): void {
        this.previousStatus = '';
        this.newStatus = '';
        this.reportsForm.controls['previousStatus'].setValue('');
        this.reportsForm.controls['newStatus'].setValue('');
    }

     /**
     * Set Default Date & Validators for Ordres Dashboard Report
     */
      setOrderDashboardReportsDeafultDateAndValidataors(): void {
        let today = new Date();
        let yesterday = new Date();
        yesterday.setDate(today.getDate() - 1);
        this.reportsForm.controls['fromDate'].setValue(this.momentConstructor(new Date(yesterday)));
        this.reportsForm.controls['toDate'].setValue(this.momentConstructor(new Date(today)));
        this.reportsForm.controls['fromDate'].setValidators([Validators.required, Utils.validateFromDate(2, 'M')]);
        this.reportsForm.controls['toDate'].setValidators([Validators.required, Utils.validateToDate(2, 'M')]);
        this.reportsForm.controls['fromDate'].updateValueAndValidity();
        this.reportsForm.controls['toDate'].updateValueAndValidity();
        /* customized for order dashborad subcategory*/
        this.dateRangeDuration = 2;
    }


    /**
     * Set Default Date & Validators for Ordres Report
     */
    setOrderReportsDeafultDateAndValidataors(): void {
        let today = new Date();
        let yesterday = new Date();
        yesterday.setDate(today.getDate() - 1);
        this.reportsForm.controls['fromDate'].setValue(this.momentConstructor(new Date(yesterday)));
        this.reportsForm.controls['toDate'].setValue(this.momentConstructor(new Date(today)));
        this.reportsForm.controls['fromDate'].setValidators([Validators.required, Utils.validateFromDate(1, 'M')]);
        this.reportsForm.controls['toDate'].setValidators([Validators.required, Utils.validateToDate(1, 'M')]);
        this.reportsForm.controls['fromDate'].updateValueAndValidity();
        this.reportsForm.controls['toDate'].updateValueAndValidity();
         /**customized for order reports subcategory **/
        this.dateRangeDuration = 1;
    }

    /**
     * Set Default Date & Validators
     */
    setDefaultDateAndValidataors(): void {
        this.reportsForm.controls['fromDate'].setValue(this.momentConstructor(this.currentDate));
        this.reportsForm.controls['toDate'].setValue(this.momentConstructor(this.currentDate));
        this.reportsForm.controls['toDate'].setValidators([Validators.required, Utils.validateToDate(this.dateRangeDuration, 'M')]);
        this.reportsForm.controls['toDate'].updateValueAndValidity();
        this.reportsForm.controls['fromDate'].setValidators([Validators.required, Utils.validateFromDate(this.dateRangeDuration, 'M')]);
        this.reportsForm.controls['fromDate'].updateValueAndValidity();
        this.dateRangeDuration = environment.reportDownloadDurationMonths;
    }

     /**
     * Set Default for email and fboId
     */
    setDefaultEnrollmentReportValues(): void {
        this.email = '';
        this.fboId = '';
        this.reportsForm.controls['email'].setValue('');
        this.reportsForm.controls['fboId'].setValue('');
    }


    /**
     * When form values are changed
     */
    formValuesChanged(): void {
        this.isSubmitted = false;
        this.dataLoadedCount = 0;
    }


    /**
     * Update the date range validation for ToDate when change from Date
     */
    fromDateChange(): void {
        this.formValuesChanged();
        setTimeout(() => {
            if (!this.reportsForm.controls['toDate'].valid
                && (this.subCategoryConstants.OrdersReport !== this.reportsForm.controls.subCategory.value) &&(this.subCategoryConstants.OrdersDashboard !== this.reportsForm.controls.subCategory.value)
                && (this.reportsForm.controls['toDate'].hasError('monthRangeValidation')
                    || this.reportsForm.controls['toDate'].hasError('toDateValidation'))) {
                this.reportsForm.controls['toDate'].setValidators([Validators.required, Utils.validateToDate(this.dateRangeDuration, 'M')]);
                this.reportsForm.controls['toDate'].updateValueAndValidity();
            } else if (!this.reportsForm.controls['toDate'].valid
                && this.reportsForm.controls['toDate'].hasError('dayRangeValidation')
                || this.reportsForm.controls['toDate'].hasError('toDateValidation')) {     
                this.reportsForm.controls['toDate'].setValidators([Validators.required, Utils.validateToDate(2, 'M')]);
                this.reportsForm.controls['toDate'].updateValueAndValidity();
            }
        }, 0);
    }

    /**
     * Update the date range validation for fromDate when change To Date
     */
    toDateChange(): void {
        this.formValuesChanged();
        setTimeout(() => {
            if (!this.reportsForm.controls['fromDate'].valid
                && (this.subCategoryConstants.OrdersReport !== this.reportsForm.controls.subCategory.value)
                && (this.reportsForm.controls['fromDate'].hasError('monthRangeValidation')
                    || this.reportsForm.controls['fromDate'].hasError('fromDateValidation'))) {
                this.reportsForm.controls['fromDate'].setValidators([Validators.required, Utils.validateFromDate(this.dateRangeDuration, 'M')]);
                this.reportsForm.controls['fromDate'].updateValueAndValidity();
            } else if (!this.reportsForm.controls['fromDate'].valid
                && (this.reportsForm.controls['fromDate'].hasError('dayRangeValidation')
                    || this.reportsForm.controls['fromDate'].hasError('fromDateValidation'))) {
                this.reportsForm.controls['fromDate'].setValidators([Validators.required, Utils.validateFromDate(1, 'M')]);
                this.reportsForm.controls['fromDate'].updateValueAndValidity();
            }
        }, 0);
    }

    /**
     * To get store info by countryCode
     */
    onSubmitRunReport() {
        this.setContainer();
        const posLocationId = this.reportsForm.controls['posLocationId'].value;
        const areaInfo = this.posLocations.find(location => location.id === +posLocationId);
        this.areaCode = areaInfo ? ((areaInfo.code ? areaInfo.code : '') + (areaInfo.name ? ' ' + areaInfo.name : '')) : '';
        if(this.reportsForm.controls['period'].value == this.period.CurrentMonth){
            const date = new Date();
            let currentMonthFirstDay = new Date(date.getFullYear(), date.getMonth(), 1).toLocaleDateString('en-CA');
            // let currentMonthLastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0).toLocaleDateString('en-CA');
            this.formattedFromDate = currentMonthFirstDay;
            this.formattedToDate = date.toLocaleDateString('en-CA');
            this.setValidDateFormat(this.formattedFromDate,this.formattedToDate);
        }
        if(this.reportsForm.controls['period'].value == this.period.PreviousMonth){
            const date = new Date();
            let previousMonthFirstDay = new Date(date.getFullYear(), date.getMonth()-1, 1).toLocaleDateString('en-CA');
            let previousMonthLastDay = new Date(date.getFullYear(), date.getMonth() -1+ 1, 0).toLocaleDateString('en-CA');
            this.formattedFromDate = previousMonthFirstDay;
            this.formattedToDate = previousMonthLastDay;
            this.setValidDateFormat(this.formattedFromDate,this.formattedToDate);
        }
        if(this.reportsForm.controls['period'].value == this.period.CustomDates){
        this.formattedFromDate = Utils.convertToSpecificDateFormat(moment(this.reportsForm.controls['fromDate'].value), DateConstants.DOBFormat);
        this.formattedToDate = Utils.convertToSpecificDateFormat(moment(this.reportsForm.controls['toDate'].value), DateConstants.DOBFormat);
        }
        if(this.reportsForm.controls['previousStatus'].value &&  this.reportsForm.controls['newStatus'].value){
            this.previousStatus = MemberStatus[this.reportsForm.controls['previousStatus'].value];
            this.newStatus =  MemberStatus[this.reportsForm.controls['newStatus'].value];
        }
        this.email = this.reportsForm.controls['email'].value;
        this.fboId = this.reportsForm.controls['fboId'].value;
       
        this.isLoading = true;
    }

    
    setValidDateFormat(fromDate:string,toDate:string){
            if(fromDate && toDate){
                    this.formattedFromDate = moment(fromDate).format(DateConstants.DOBFormat);
                    this.formattedToDate = moment(toDate).format(DateConstants.DOBFormat);              
            }
        }

    /**
     * To Set Container when click run at second time
     */
    setContainer(): void {
        if (this.dataLoadedCount === 0) {
            this.isSubmitted = true;
        } else {
            this.isSubmitted = false;
            setTimeout(x => {
                this.isSubmitted = true;
            }, 0);
        }
    }

    /**
     * To Get Pos Payment Methods
     */
    getPosPaymentMethod() {
        this._customerService.getPosPaymentMethod().subscribe(response => {
            if (response && response.length > 0) {
                this.posPaymentMethods = response;
            } else {
                this.posPaymentMethods = [];
            }
        }, (error) => {
            this.posPaymentMethods = [];
        });
    }

    /**
     * To Handle the spinner load
     */
    dataLoaded(): void {
        this.dataLoadedCount++;
        this.isLoading = false;
    }

    addToFavorite() {
    }

    /**
     * To load screen based on tab selected
     */
    selectTab(tab: any): void {
        this.activeTab = tab;
    }


    callingMultiSelect() {
          this.selectedItems = [
           
        ];
        this.dropdownSettings =  {
          singleSelection: false,
          text: "Select",
          selectAllText: "Select All",
          unSelectAllText: "UnSelect All",
          enableSearchFilter: false,
          classes: "myclass custom-class select.ng-valid",
          badgeShowLimit: 1
        };
      }
    
      onItemSelect(item: any) {
        this.posLocations = []; 
        this.reportsForm.controls['posLocationId'].setValue('');
        this.reportsForm.controls['subCategory'].setValue('');
         const store = this.stores.find((x)=> x.countryId == (+item.id));
          if (store && store.isocodeThree) {
              if(this.countryAndStoreData && this.countryAndStoreData.length > 0) {
                const data =  this.countryAndStoreData.find((x) => x.countryCode == store.isocodeThree);
                this.storeId = null;
                if(data) {
                    this.storeId = data.storeId;
                    this.finalStoreIds.push(this.storeId);
                    if(!this.selectAllStores && this.reportsForm.controls['reportCategory'].value){
                        this.onReportCategoryChange(this.reportsForm.controls['reportCategory'].value);
                      }
                }
              }
              if(!this.storeId) {
              this._orderService.getStoreInfo(store.isocodeThree).subscribe((response) => {
                  if (response) {
                      this.storeId = response.id;
                          this.finalStoreIds.push(this.storeId);
                          this.countryAndStoreData.push({
                          countryCode:store.isocodeThree,
                          countryId:item.id,
                          storeId: this.storeId
                         
                      });
                      if(!this.selectAllStores && this.storeId && this.reportsForm.controls['reportCategory'].value){
                        this.onReportCategoryChange(this.reportsForm.controls['reportCategory'].value);
                      }
                  }
              });
            }
          }
          this.countryIdForBsn.push(item.id);
          this.countryIdForIBAN.push(item.id);
      }

      OnItemDeSelect(item: any) {
        this.reportsForm.controls['posLocationId'].setValue('');
        this.reportsForm.controls['subCategory'].setValue('');
          const data = this.countryAndStoreData.find((x) => x.countryId == item.id);
          if(data && data.storeId) {
            this.finalStoreIds = this.finalStoreIds.filter(storeId=>{
                return data.storeId !== storeId;
           });
          }
            if(this.reportsForm.controls['reportCategory'].value){
               this.onReportCategoryChange(this.reportsForm.controls['reportCategory'].value);
          }
          this.countryIdForBsn = this.countryIdForBsn.filter(countryId=>{
                     return  item.id !== countryId;
          })
          this.countryIdForIBAN = this.countryIdForIBAN.filter(countryId => {
              return item.id !== countryId;
          })
      }

      onSelectAll(items: any) {
        this.selectAllStores = true;
        this.finalStoreIds = [];
        this.posLocations = [];
        this.reportsForm.controls['posLocationId'].setValue('');
        this.reportsForm.controls['subCategory'].setValue('');
        items.forEach(item => {
        this.onItemSelect(item);
        });
        this.countryIdForBsn = [];
        this.countryIdForIBAN = [];
        items.forEach(item=>{
            this.countryIdForBsn.push(item.id);
        })
        items.forEach(item=>{
            this.countryIdForIBAN.push(item.id);
        })
        if(this.selectAllStores && this.reportsForm.controls['reportCategory'].value){
            this.onReportCategoryChange(this.reportsForm.controls['reportCategory'].value);
          }
          this.selectAllStores = false;
        // this.finalStoreIds.push(items);
      }
      onDeSelectAll(items: any) {
        this.reportsForm.controls['posLocationId'].setValue('');
        this.reportsForm.controls['subCategory'].setValue('');
        this.finalStoreIds = [];
        if(this.reportsForm.controls['reportCategory'].value){
            this.onReportCategoryChange(this.reportsForm.controls['reportCategory'].value);
          }
        this.countryIdForBsn = [];
        this.countryIdForIBAN = [];
    }

    /**
    * To get member status
    */
    getMemberStatus() {
        this._customerService.getMemberStatusesFromTitan().subscribe(response => {
            if (response) {
                this.memberStatus = response;
            } else {
                this.memberStatus = [];
            }
        }, (error) => {
            this.memberStatus = [];
        });
    }
}


// WEBPACK FOOTER //
// ./src/app/customerservice/components/reports/reports.component.ts